/** ----------------------------------------
    Interface
 ---------------------------------------- */

import { NotificationStore } from '@interface/store/Notification';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {
  totalUnread: (state: NotificationStore) => Object.keys(state.unread).length,
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters